import { Outlet } from "@tanstack/react-router";
import DashboardLayout from "../layouts/DashboardLayout";

const Root = () => {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
};

export default Root;
